import WhatsNextCard from '../WhatsNextCard'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import NextPathwayCard from 'components/shared/NextPathwayCard/NextPathwayCard'

const WhatsNextRecommendations = ({ recommendedPathways }) => {
  const { t } = useTranslation()

  const trySomethingNewDescription = t(
    'project.project_complete.try-something-new'
  )

  return (
    <WhatsNextCard description={trySomethingNewDescription} showPathsButton>
      {recommendedPathways.map((pathway) => (
        <NextPathwayCard
          key={pathway.data.id}
          pathway={pathway.data.attributes}
        />
      ))}
    </WhatsNextCard>
  )
}

WhatsNextRecommendations.propTypes = {
  recommendedPathways: PropTypes.arrayOf(
    PropTypes.shape({
      data: PropTypes.shape({
        id: PropTypes.string.isRequired,
        attributes: PropTypes.object.isRequired,
      }).isRequired,
    })
  ).isRequired,
}

export default WhatsNextRecommendations
